import { KeycloakConfig } from 'keycloak-js';

export const keycloakConfig: KeycloakConfig = {
  url: 'https://auth.fbox.pics',
  realm: 'videowand-leipzig-de',
  clientId: 'videowand-frontend'
};
